import React from 'react';
import PageSection from '../components/PageSection';

const highlights = [
  {
    title: 'Scrivici per un preventivo',
    description:
      'Hai un’idea da realizzare? Raccontaci bisogni e tempi: rispondiamo entro 24 ore lavorative.',
    icon: '💡'
  },
  {
    title: 'Siamo sempre al tuo fianco',
    description:
      'Dal workshop iniziale al rilascio, ti ancoriamo a un team dedicato di product e dev.',
    icon: '🤝'
  },
  {
    title: 'Supporto continuo',
    description:
      'Ticketing, canali Slack condivisi e retro dedicate per migliorare sprint dopo sprint.',
    icon: '⚡️'
  }
];

const Contatti = () => {
  return (
    <>
      <section className="hero hero-secondary">
        <div className="container hero-inner small">
          <p className="eyebrow">Contatti</p>
          <h1>Parliamo del tuo prossimo progetto digitale.</h1>
          <p className="hero-subtitle">
            Contattaci per un preventivo sulla soluzione che vuoi realizzare: siamo qui
            per trasformare la tua idea in prodotto.
          </p>
        </div>
      </section>

      <PageSection>
        <div className="contact-layout single-column">
          <div className="contact-info">
            <div className="contact-card highlight-card">
              <p className="contact-card-title">Contattaci subito</p>
              <a
                className="contact-lead"
                href="mailto:sales@helpsoftware.it"
              >
                sales@helpsoftware.it
                <span aria-hidden="true"> →</span>
              </a>
              <p className="contact-card-title spacing-top">Sede legale</p>
              <p>Via Luigi Pulci 12, 20126 – Milano (MI)</p>
              <p className="contact-card-title spacing-top">Sede amministrativa</p>
              <p>Via Alberto Nota 20, 20126 – Milano (MI)</p>
              <p className="contact-card-title spacing-top">Sito web</p>
              <p>www.helpsoftware.it</p>
            </div>
            <div className="contact-highlights">
              {highlights.map(item => (
                <div key={item.title} className="contact-highlight-card">
                  <span className="icon-chip large">{item.icon}</span>
                  <div>
                    <p className="icon-item-label">{item.title}</p>
                    <p className="icon-item-description">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </PageSection>
    </>
  );
};

export default Contatti;
